import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/styles';
import useToast from '../../../components/Toast/hooks/useToast';
import GradeEstimates from './LeadEstimates/GradeEstimates';
import LeadsByChannel from './LeadEstimates/LeadsByChannel';
import ImportantMetrix from './LeadEstimates/ImportantMetrix';
import ActualPredictive from './LeadEstimates/ActualPredictive';
import PredictiveScoringEndpoints from '../PredictiveScoringEndpoints';
import useApiService from '../../../services/api.service';
import {
	OppurtunityScoringTableColumns,
	setDataforOppurtunityScoring,
} from './LeadEstimates/LeadScoringData';
import WinRateOppurtunityScoring from './LeadEstimates/WinRateForOppurtunityScoring';

const OppurtunityScoring: React.FC<any> = (props: any) => {
	const theme: any = useTheme();
	const toaster: any = useToast();
	const APIService: any = useApiService();
	const [winRateData, setWinRateData] = useState();
	const [isLoading, setisLoading]: any = useState(true);
	const [gradeEstimatesData, setGradeEstimatesData] = useState();
	const [stage, setStage]: any = useState('All');
	const [tableLimit, setTableLimit]: any = useState(10);
	const [tableOffset, setTableOffset]: any = useState(1);
	const [leadsByChannelData, setleadsByChannelData] = useState();
	const [leadForecastData, setleadForecastData]: any = useState();
	const [DateCategories, setDateCategories]: any = useState();
	const [ImportantMetrixData, setImportantMetrixData]: any = useState();
	const [selectedGradeType, setSelectedGradeType] = useState('overall');
	const getSelectedGradeType = (gradeType: any) => {
		setSelectedGradeType(gradeType);
	};
	const handleStage = (data: any) => {
		setStage(data);
	};
	const handleLimit = (data: any) => {
		setTableLimit(data); // Set the limit locally
		setTableOffset(Math.ceil((tableOffset * tableLimit) / data)); // Calculate and set the new offset based on current offset and limit
	};

	const handleOffset = (data: any) => {
		setTableOffset(data); // Set the offset locally
	};

	const getDataForGrade = (grade: string, graph: any) => {
		const temp = JSON.parse(JSON.stringify(leadForecastData || {}));
		switch (grade) {
			case 'grade a':
				return temp?.A?.[graph];
			case 'grade b':
				return temp?.B?.[graph];
			case 'grade c':
				return temp?.C?.[graph];
			case 'overall':
				return temp?.All?.[graph];
			default:
				return [];
		}
	};
	const data = [
		{
			title: 'Opportunity Trend',
			actuallabel: 'Actual Opportunities',
			predictedlabel: 'Predictive Opportunities',
			actualdata: getDataForGrade(selectedGradeType, 'actual_oppr'),
			predictivedata: getDataForGrade(selectedGradeType, 'forecasted_oppr'),
		},
		{
			title: 'Revenue Trend',
			actuallabel: 'Actual Revenue',
			predictedlabel: 'Predictive Revenue',
			actualdata: getDataForGrade(selectedGradeType, 'actual_revenue'),
			predictivedata: getDataForGrade(selectedGradeType, 'forecasted_revenue'),
		},
		{
			title: 'Closed Won Trend',
			actuallabel: 'Actual Closed Won',
			predictedlabel: 'Predictive  Closed Won',
			actualdata: getDataForGrade(selectedGradeType, 'actual_deal'),
			predictivedata: getDataForGrade(selectedGradeType, 'forecasted_deal'),
		},
	];
	const getLeadScoringData = async () => {
		try {
			setisLoading(true);
			const request = {
				reqBody: {
					level: 2,
					limit: tableLimit,
					offset: tableOffset,
					start_date: props.dateRange.start_date,
					end_date: props.dateRange.end_date,
					stage: stage ? 'Open' : 'All',
				},
			};
			const res = await APIService.post(
				PredictiveScoringEndpoints.leadScoring(request),
				true
			);
			setData(res);
		} catch (err) {
			toaster.addToast({
				message: 'Kindly, enable Train Model',
				timeout: 3000,
				type: 'error',
			});
			console.error(err);
		} finally {
			setisLoading(false);
		}
	};
	useEffect(() => {
		getLeadScoringData();
	}, [tableLimit, tableOffset, props?.dateRange, stage]);

	useEffect(() => {
		setReports(data);
	}, [leadForecastData]);

	const [reports, setReports]: any = useState([]);

	const setData = (res: any) => {
		setWinRateData(res?.average);
		setGradeEstimatesData(res?.lead_score);
		setleadsByChannelData(res?.channel_count);
		setleadForecastData(res?.time_series);
		setDateCategories(res?.time_series?.ds);
		setImportantMetrixData(res?.analysis_dict || []);
	};

	return (
		<>
			<Grid
				container
				className='tab_container'
				style={{ marginBottom: '50px' }}
			>
				<WinRateOppurtunityScoring
					xsvalue={6}
					setData={setDataforOppurtunityScoring}
					Data={winRateData}
					onGradeTypeChange={getSelectedGradeType}
					isLoading={isLoading}
				/>
				<GradeEstimates
					stagelead={stage}
					Data={gradeEstimatesData}
					tablecol={OppurtunityScoringTableColumns}
					grade={selectedGradeType}
					isLoading={isLoading}
					stage={handleStage}
					limit={handleLimit}
					offset={handleOffset}
				/>
				<LeadsByChannel
					Data={leadsByChannelData}
					isLoading={isLoading}
					title={'Opportunities By Channel'}
				/>
				{reports.map((report: any, index: any) => (
					<ActualPredictive
						key={index}
						index={index}
						title={report.title}
						actualdata={report.actualdata}
						predicteddata={report.predictivedata}
						actuallabel={report.actuallabel}
						predictedlabel={report.predictedlabel}
						datecategories={DateCategories}
						onGradeChange={(selectedGrade: any, index: any) => {
							let tempData = [...reports];
							// Update actualdata and predicteddata based on the grade selected
							switch (report.title) {
								case 'Opportunity Trend':
									tempData[index].actualdata = getDataForGrade(
										selectedGrade,
										'actual_oppr'
									);
									tempData[index].predictivedata = getDataForGrade(
										selectedGrade,
										'forecasted_oppr'
									);
									break;
								case 'Revenue Trend':
									tempData[index].actualdata = getDataForGrade(
										selectedGrade,
										'actual_revenue'
									);
									tempData[index].predictivedata = getDataForGrade(
										selectedGrade,
										'forecasted_revenue'
									);
									break;
								case 'Closed Won Trend':
									tempData[index].actualdata = getDataForGrade(
										selectedGrade,
										'actual_deal'
									);
									tempData[index].predictivedata = getDataForGrade(
										selectedGrade,
										'forecasted_deal'
									);
									break;
								default:
									break;
							}
							setReports(tempData);
						}}
						grade={selectedGradeType}
						isLoading={isLoading}
					/>
				))}
				<ImportantMetrix Data={ImportantMetrixData} isLoading={isLoading} />
			</Grid>
		</>
	);
};

export default React.memo(OppurtunityScoring);
